/* ============================================
   WIZZYLIFE THEME — Interactive JavaScript
   Cart, Swipeable Gallery, Tabs, Timer, Toast
   ============================================ */

(function() {
  'use strict';

  const WL = {
    cart: [],
    cartCount: window.theme?.cartCount || 0,
    moneyFormat: window.theme?.moneyFormat || '${{amount}}',
    routes: window.theme?.routes || {},
  };

  /* ============================================
     UTILITIES
     ============================================ */
  function $(selector, context) {
    return (context || document).querySelector(selector);
  }
  function $$(selector, context) {
    return Array.from((context || document).querySelectorAll(selector));
  }
  function on(event, selector, handler) {
    document.addEventListener(event, function(e) {
      const el = e.target.closest(selector);
      if (el) handler.call(el, e);
    });
  }
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return WL.moneyFormat.replace('{{amount}}', value).replace('{{ amount }}', value);
  }
  function showToast(message) {
    const toast = $('#wl-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3000);
  }

  /* ============================================
     CART DRAWER
     ============================================ */
  function openCartDrawer() {
    const drawer = $('#wl-cart-drawer');
    if (drawer) drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    const drawer = $('#wl-cart-drawer');
    if (drawer) drawer.classList.remove('active');
    document.body.style.overflow = '';
  }
  function updateCartCount(count) {
    const badge = $('#wl-cart-count');
    if (badge) {
      badge.textContent = count;
      badge.setAttribute('data-count', count);
      badge.style.animation = 'none';
      badge.offsetHeight;
      badge.style.animation = 'badgePulse 1.5s infinite';
    }
  }
  function renderCartDrawer(items) {
    const container = $('#wl-cart-items');
    const subtotalEl = $('#wl-cart-subtotal');
    if (!container) return;

    if (!items || items.length === 0) {
      container.innerHTML = '<div style="text-align:center;padding:40px 20px;"><span style="font-size:48px;display:block;margin-bottom:16px;">🛒</span><p style="color:#6B7280;">Your cart is empty</p></div>';
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      return;
    }

    let html = '';
    let total = 0;
    items.forEach((item, index) => {
      total += item.line_price;
      html += `
        <div class="wl-cart-item" data-line="${index + 1}">
          <div class="wl-cart-item__image">
            ${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : ''}
          </div>
          <div class="wl-cart-item__details">
            <h3 class="wl-cart-item__title"><a href="${item.url}">${item.title}</a></h3>
            ${item.variant_title ? `<p class="wl-cart-item__variant">${item.variant_title}</p>` : ''}
            <p class="wl-cart-item__price">${formatMoney(item.line_price)}</p>
            <div class="wl-cart-item__actions">
              <div class="wl-quantity-selector wl-quantity-selector--small">
                <button type="button" class="wl-qty-btn" data-action="decrease" data-line="${index + 1}">−</button>
                <input type="number" value="${item.quantity}" min="0" class="wl-qty-input" data-line="${index + 1}">
                <button type="button" class="wl-qty-btn" data-action="increase" data-line="${index + 1}">+</button>
              </div>
              <button class="wl-cart-item__remove" data-line="${index + 1}">Remove</button>
            </div>
          </div>
        </div>
      `;
    });
    container.innerHTML = html;
    if (subtotalEl) subtotalEl.textContent = formatMoney(total);
  }

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      WL.cart = data.items;
      WL.cartCount = data.item_count;
      updateCartCount(data.item_count);
      renderCartDrawer(data.items);
    } catch (err) {
      console.error('Cart fetch error:', err);
    }
  }

  async function addToCart(variantId, quantity) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await fetchCart();
      openCartDrawer();
      showToast('✨ Added to cart!');
    } catch (err) {
      console.error('Add to cart error:', err);
      showToast('❌ Could not add to cart');
    }
  }

  async function updateCartLine(line, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (!res.ok) throw new Error('Update failed');
      await fetchCart();
    } catch (err) {
      console.error('Update cart error:', err);
    }
  }

  on('click', '#wl-cart-toggle', () => { fetchCart(); openCartDrawer(); });
  on('click', '.wl-cart-drawer__overlay', closeCartDrawer);
  on('click', '.wl-cart-drawer__close', closeCartDrawer);
  on('click', '.wl-product-card__quick-add', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const variantId = this.getAttribute('data-variant-id');
    if (variantId) addToCart(variantId, 1);
  });

  on('click', '.wl-cart-item__remove', function() {
    const line = this.getAttribute('data-line');
    updateCartLine(line, 0);
  });
  on('click', '.wl-cart-item .wl-qty-btn', function() {
    const line = this.getAttribute('data-line');
    const input = $(`.wl-cart-item .wl-qty-input[data-line="${line}"]`);
    let qty = parseInt(input.value) || 0;
    if (this.getAttribute('data-action') === 'increase') qty++;
    else qty = Math.max(0, qty - 1);
    input.value = qty;
    updateCartLine(line, qty);
  });

  /* ============================================
     MOBILE MENU
     ============================================ */
  const mobileMenu = $('#wl-mobile-menu');
  const menuToggle = $('#wl-mobile-menu-toggle');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('active');
      menuToggle.classList.toggle('active');
      document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
    });
    $('.wl-mobile-menu__overlay')?.addEventListener('click', () => {
      mobileMenu.classList.remove('active');
      menuToggle.classList.remove('active');
      document.body.style.overflow = '';
    });
    $('.wl-mobile-menu__close')?.addEventListener('click', () => {
      mobileMenu.classList.remove('active');
      menuToggle.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  /* ============================================
     SEARCH OVERLAY
     ============================================ */
  const searchOverlay = $('#wl-search-overlay');
  const searchToggle = $('#wl-search-toggle');
  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      setTimeout(() => $('.wl-search-overlay__input')?.focus(), 100);
    });
    $('.wl-search-overlay__close')?.addEventListener('click', () => {
      searchOverlay.classList.remove('active');
      document.body.style.overflow = '';
    });
    $('.wl-search-overlay__overlay')?.addEventListener('click', () => {
      searchOverlay.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  /* ============================================
     HERO SLIDER
     ============================================ */
  const heroSlides = $('.wl-hero__slides');
  const heroDots = $$('.wl-hero__dot');
  if (heroSlides && heroDots.length > 0) {
    let currentSlide = 0;
    const totalSlides = heroDots.length;

    function goToSlide(index) {
      currentSlide = index;
      heroSlides.style.transform = `translateX(-${index * 100}%)`;
      heroDots.forEach((dot, i) => dot.classList.toggle('active', i === index));
    }

    heroDots.forEach((dot, i) => {
      dot.addEventListener('click', () => goToSlide(i));
    });

    setInterval(() => {
      goToSlide((currentSlide + 1) % totalSlides);
    }, 5000);
  }

  /* ============================================
     SWIPEABLE PRODUCT GALLERY
     ============================================ */
  (function initGallery() {
    const track = $('#wl-gallery-track');
    const slides = $$('.wl-product-gallery__slide');
    const dots = $$('.wl-gallery-dot');
    const thumbs = $$('.wl-product-gallery__thumb');
    const prevBtn = $('#wl-gallery-prev');
    const nextBtn = $('#wl-gallery-next');

    if (!track || slides.length === 0) return;
    if (slides.length === 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    let currentIndex = 0;
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let startTime = 0;

    function goToImage(index) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.style.transform = `translateX(-${currentIndex * 100}%)`;

      slides.forEach((s, i) => s.classList.toggle('active', i === currentIndex));
      dots.forEach((d, i) => d.classList.toggle('active', i === currentIndex));
      thumbs.forEach((t, i) => t.classList.toggle('active', i === currentIndex));

      // Scroll thumbnail into view
      const activeThumb = thumbs[currentIndex];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    // Arrow buttons
    prevBtn?.addEventListener('click', () => goToImage(currentIndex - 1));
    nextBtn?.addEventListener('click', () => goToImage(currentIndex + 1));

    // Dot navigation
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goToImage(i));
    });

    // Thumbnail navigation
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goToImage(i));
    });

    // Touch / Swipe support
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      currentX = startX;
      isDragging = true;
      startTime = Date.now();
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
      const diff = currentX - startX;
      const offset = -currentIndex * 100 + (diff / track.offsetWidth * 100);
      track.style.transform = `translateX(${offset}%)`;
    }, { passive: true });

    track.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';

      const diff = currentX - startX;
      const elapsed = Date.now() - startTime;
      const velocity = Math.abs(diff) / elapsed;

      // Swipe threshold: 50px OR fast flick (velocity > 0.5)
      if (diff < -50 || (diff < 0 && velocity > 0.5)) {
        goToImage(currentIndex + 1);
      } else if (diff > 50 || (diff > 0 && velocity > 0.5)) {
        goToImage(currentIndex - 1);
      } else {
        goToImage(currentIndex);
      }
    });

    track.addEventListener('touchcancel', () => {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
      goToImage(currentIndex);
    });

    // Mouse drag support (desktop)
    track.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      currentX = startX;
      isDragging = true;
      startTime = Date.now();
      track.style.transition = 'none';
      track.style.cursor = 'grabbing';
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      currentX = e.clientX;
      const diff = currentX - startX;
      const offset = -currentIndex * 100 + (diff / track.offsetWidth * 100);
      track.style.transform = `translateX(${offset}%)`;
    });

    track.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
      track.style.cursor = '';

      const diff = currentX - startX;
      if (diff < -50) goToImage(currentIndex + 1);
      else if (diff > 50) goToImage(currentIndex - 1);
      else goToImage(currentIndex);
    });

    track.addEventListener('mouseleave', () => {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
      track.style.cursor = '';
      goToImage(currentIndex);
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      const gallery = $('.wl-product-gallery');
      if (!gallery || !gallery.contains(document.activeElement)) return;
      if (e.key === 'ArrowLeft') goToImage(currentIndex - 1);
      if (e.key === 'ArrowRight') goToImage(currentIndex + 1);
    });

  })();

  /* ============================================
     PRODUCT TABS
     ============================================ */
  const tabButtons = $$('.wl-tab-btn');
  const tabPanels = $$('.wl-tab-panel');
  if (tabButtons.length > 0) {
    tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.getAttribute('data-tab');
        tabButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        tabPanels.forEach(p => {
          p.classList.toggle('active', p.getAttribute('data-panel') === tab);
        });
      });
    });
  }

  /* ============================================
     QUANTITY SELECTORS
     ============================================ */
  on('click', '.wl-qty-btn', function() {
    const container = this.closest('.wl-quantity-selector');
    const input = container.querySelector('.wl-qty-input');
    let val = parseInt(input.value) || 1;
    if (this.getAttribute('data-action') === 'increase') val++;
    else val = Math.max(1, val - 1);
    input.value = val;
  });

  /* ============================================
     PRODUCT FORM — AJAX ADD TO CART
     ============================================ */
  const productForm = $('#wl-product-form');
  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const submitBtn = productForm.querySelector('[type="submit"]');
      const loader = submitBtn?.querySelector('.wl-btn__loader');
      const text = submitBtn?.querySelector('.wl-btn__text');

      if (submitBtn) submitBtn.disabled = true;
      if (loader) loader.hidden = false;
      if (text) text.hidden = true;

      const formData = new FormData(productForm);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity')) || 1;

      try {
        await addToCart(variantId, quantity);
      } finally {
        if (submitBtn) submitBtn.disabled = false;
        if (loader) loader.hidden = true;
        if (text) text.hidden = false;
      }
    });
  }

  /* ============================================
     VARIANT SELECTORS
     ============================================ */
  on('click', '.wl-option-btn', function() {
    const siblings = this.parentElement.querySelectorAll('.wl-option-btn');
    siblings.forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');
  });

  /* ============================================
     COUNTDOWN TIMER — FIXED & ROBUST
     ============================================ */
  (function initTimers() {
    const timers = $$('.wl-flash-sale__timer');
    if (timers.length === 0) return;

    timers.forEach(timer => {
      let endTime = timer.getAttribute('data-end-time');

      // Fallback: if no end time set, default to 24 hours from now
      let end;
      if (endTime) {
        end = new Date(endTime);
      }
      if (!endTime || isNaN(end.getTime())) {
        end = new Date();
        end.setHours(end.getHours() + 24);
      }

      const hoursEl = timer.querySelector('.wl-timer__hours');
      const minutesEl = timer.querySelector('.wl-timer__minutes');
      const secondsEl = timer.querySelector('.wl-timer__seconds');

      if (!hoursEl || !minutesEl || !secondsEl) return;

      function updateTimer() {
        const now = new Date().getTime();
        const diff = end.getTime() - now;

        if (diff <= 0) {
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          return;
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
      }

      updateTimer();
      setInterval(updateTimer, 1000);
    });
  })();

  /* ============================================
     HORIZONTAL SCROLL — MOUSE WHEEL
     ============================================ */
  $$('.wl-product-scroll, .wl-ugc-scroll, .wl-flash-sale__products').forEach(el => {
    el.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        el.scrollLeft += e.deltaY;
      }
    }, { passive: false });
  });

  /* ============================================
     SMOOTH SCROLL FOR ANCHORS
     ============================================ */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = $(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ============================================
     LAZY LOAD IMAGES
     ============================================ */
  if ('IntersectionObserver' in window) {
    const imgObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imgObserver.unobserve(img);
        }
      });
    });
    $$('img[data-src]').forEach(img => imgObserver.observe(img));
  }

  /* ============================================
     INITIALIZE
     ============================================ */
  document.addEventListener('DOMContentLoaded', () => {
    fetchCart();
    console.log('🪄 WizzyLife Theme initialized — Gallery swipe & timer fixed');
  });

  window.WizzyLife = WL;

})();
